import { Box, Paper, Typography, Grid } from "@mui/material";

export const LookupTnResultInfo = () => {
  return (
    <>
      <Box id="look-tn-results-info"></Box>
      <Paper
        className="lookup-tn-help-page-result-info-container"
        sx={{ padding: 4, borderRadius: 2, mt: 4 }}
        elevation={4}
      >
        <Typography variant="h4">Result Chart</Typography>
        <Grid
          container
          sx={{
            mt: 4,
            "--Grid-borderWidth": "1px",
            borderTop: "var(--Grid-borderWidth) solid black",
            borderLeft: "var(--Grid-borderWidth) solid black",
            "& > div": {
              borderRight: "var(--Grid-borderWidth) solid black",
              borderBottom: "var(--Grid-borderWidth) solid black",
            },
          }}
        >
          <LookupTnHelpCell header>type</LookupTnHelpCell>
          <LookupTnHelpCell header>cic</LookupTnHelpCell>
          <LookupTnHelpCell header>spsr</LookupTnHelpCell>
          <LookupTnHelpCell header>campaign_id</LookupTnHelpCell>
          <LookupTnHelpCell header large>
            Notes
          </LookupTnHelpCell>
          {
            // Line 1
          }
          <LookupTnHelpCell>Mobile</LookupTnHelpCell>
          <LookupTnHelpCell>Industry NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Absent</LookupTnHelpCell>
          <LookupTnHelpCell>Absent</LookupTnHelpCell>
          <LookupTnHelpCell large>Mobile (Cellular)</LookupTnHelpCell>
          {
            // Line 2
          }
          <LookupTnHelpCell>Mobile</LookupTnHelpCell>
          <LookupTnHelpCell>nnSR NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Industry NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Absent</LookupTnHelpCell>
          <LookupTnHelpCell large>
            Mobile - voice and messaging bifurcated (MVNO)
          </LookupTnHelpCell>
          {
            // Line 3
          }
          <LookupTnHelpCell>Fixed</LookupTnHelpCell>
          <LookupTnHelpCell>Industry NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Absent</LookupTnHelpCell>
          <LookupTnHelpCell>Absent</LookupTnHelpCell>
          <LookupTnHelpCell large>Fixed line (landline, POTS)</LookupTnHelpCell>
          {
            // Line 4
          }
          <LookupTnHelpCell>Fixed</LookupTnHelpCell>
          <LookupTnHelpCell>nnSR NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Industry NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Absent</LookupTnHelpCell>
          <LookupTnHelpCell large>SMS enabled landline (P2P)</LookupTnHelpCell>
          {
            // Line 5
          }
          <LookupTnHelpCell>Fixed</LookupTnHelpCell>
          <LookupTnHelpCell>nnSR NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Industry NNID</LookupTnHelpCell>
          <LookupTnHelpCell>Campaign ID</LookupTnHelpCell>
          <LookupTnHelpCell large>SMS enabled landline (A2P)</LookupTnHelpCell>
        </Grid>
        <Typography variant="subtitle1" sx={{ mt: 4 }}>
          If <span className="bold">"cic" is present and "spsr" is absent</span>{" "}
          - <span style={{ color: "red" }}>cic = Industry NNID</span>
        </Typography>
        <Typography variant="subtitle1">
          If{" "}
          <span className="bold">"cic" is present and "spsr" is present</span>{" "}
          <span style={{ color: "green" }}>- cic = nnSR NNID</span> and{" "}
          <span style={{ color: "red" }}>spsr = Industry NNID</span>
        </Typography>
      </Paper>
    </>
  );
};

type LookupTnHelpCellProps = {
  children: string | JSX.Element | JSX.Element[];
  large?: boolean;
  header?: boolean;
};

const ABSENT = "Absent";
const MOBILE = "Mobile";
const FIXED = "Fixed";
const NNSR_NNID = "nnSR NNID";
const INDUSTRY_NNID = "Industry NNID";

const LIGHT_GREEN_COLOR = "rgb(185, 240, 206)";
const LIGHT_BLUE_COLOR = "rgb(185, 214, 240)";
// const LIGHT_GREY_COLOR = "rgb(148, 163, 184)";

export const LookupTnHelpCell = ({
  children,
  large = false,
  header = false,
}: LookupTnHelpCellProps) => {
  let backgroundColor: string = "";
  let textColor: string = "";

  if (children.toString().includes(ABSENT)) {
    backgroundColor = "yellow";
  } else if (children.toString().includes(MOBILE)) {
    backgroundColor = LIGHT_BLUE_COLOR;
  } else if (
    children.toString().includes(FIXED) ||
    children.toString().includes("landline")
  ) {
    backgroundColor = LIGHT_GREEN_COLOR;
  }
  // else if (header) {
  //   backgroundColor = LIGHT_GREY_COLOR;
  // }
  if (children.toString().includes(NNSR_NNID)) {
    textColor = "Green";
  } else if (children.toString().includes(INDUSTRY_NNID)) {
    textColor = "Red";
  }

  return (
    <Grid
      size={{ xs: 12, sm: 12, md: large ? 4 : 2, lg: large ? 4 : 2 }}
      sx={{
        backgroundColor: backgroundColor,
        color: textColor,
        padding: 1.25,
        paddingTop: 3,
      }}
    >
      <Typography sx={{ fontWeight: header ? "bold" : "" }}>
        {children}
      </Typography>
    </Grid>
  );
};
